export default __webpack_public_path__ + "static/media/section_bg-marketing_slides.png";